<template>
  <div class="chart-box">
    <div :class="className" :id="id" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
export default {
  name: "LiquidFill",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.chartData) {
      this.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    initChart() {
      var option = {
        series: [{
          type: 'liquidFill',
          radius: '95%',
          data: this.chartData.value
        }]
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<style scoped lang="less">
.chart-box {
  width: 100%;
  height: 100%;
  position: relative;
  .legend {
    position: absolute;
    z-index: 99;
    top: 50%;
    transform: translateY(-50%);
    li {
      width: 100%;
      height: 25px;
      font-size: 16px;
      margin-bottom: 14px;
      > div {
        float: left;
      }
      .rect {
        width: 14px;
        height: 14px;
        margin-top: 4px;
      }
      .name {
        margin: 0 16px 0 6px;
      }
      .proportion {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}
</style>
